module.exports = __webpack_public_path__ + "static/media/facebook.57d3f125.svg";